<template>
  <v-list-item @click="itemClick()" class="queue-list-item">
    <v-list-item-avatar>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-avatar v-on="on" color="primary" size="32">
            <span class="white--text">{{ callsNum }}</span>
          </v-avatar>
        </template>
        <span>{{ $t('queues.tooltip.listCalls') }}</span>
      </v-tooltip>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        {{ queue.name }}
      </v-list-item-title>
      <v-list-item-subtitle>
        <v-icon small>mdi-headset</v-icon>
        {{ $t('queues.body.agents') }}: {{ agentsNum }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom light>
        <template v-slot:activator="{ on }">
          <v-btn class="watch-btn"
            icon small v-on="on" @click="toggleWatch(queue)">
            <v-icon small :color="queue.watch ? 'green' : 'grey lighten-2'">
              mdi-eye{{ queue.watch ? '' : '-off' }}
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ $t('queues.tooltip.watch') }}
        </span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'queues-list-item',
  props: {
    queue: {
      type: Object,
      required: true
    }
  },
  computed: {
    callsNum: function () {
      return this.queue.calls?.length ?? 0
    },
    agentsNum: function () {
      return this.queue.agents?.length ?? 0
    }
  },
  methods: {
    ...mapActions({ toggleWatch: 'queues/toggleWatch' }),
    itemClick: function () {
      return true
    }
  }
}
</script>

<style scoped>
</style>
